<h2 class="!ml-0 !mb-3 text-[26px]">{{ "EXPLORER" | translate }}</h2>
<ul>
  @for (item of navigationItems; track item.route) {
  <li
    class="ml-[5px] mb-2.5"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{exact: true}"
  >
    <button
      class="flex items-center w-full"
      [routerLink]="item.route"
      (click)="onLinkClick()"
      (keyup)="onKeyUp($event, 'onLinkClick')"
      tabindex="0"
    >
      <span [class]="item.iconClasses"></span>
      {{ item.labelKey | translate }}
    </button>
  </li>
  }
</ul>

<ng-container
  class="mask-[url(/assets/images/icons/search.svg)] mask-[url(/assets/images/icons/calendar.svg)] mask-[url(/assets/images/icons/star.svg)] mask-[url(/assets/images/icons/collaborators.svg)] mask-[url(/assets/images/icons/stats.svg)]"
></ng-container>
